/**
 * Sits above the UI and takes over the display when a user is unauthorized, not registered or has logged out.
 */

import { useRecoilValue } from "recoil";

import { AuthScreenAtom, Authorization } from "../../state/authAtoms";
import { OwnerNameAssociatedWithEmail } from "../../state/authSelectors";
import { DemoMode } from "../../state/uiAtoms";
import RefreshSpinner from "../Refresh";
import Login from "./Login";
import { LoginOrSignUp } from "./LoginOrSignUp";
import RegisterOwnerName from "./register/RegisterOwnerName";
import SignUp from "./register/SignUp";

function Auth() {
  const screen = useRecoilValue(AuthScreenAtom);
  const auth = useRecoilValue(Authorization);
  const inDemoMode = useRecoilValue(DemoMode);
  const ownerNameAssociatedWithEmail = useRecoilValue(OwnerNameAssociatedWithEmail);

  if (auth.initializingFireBaseUser && !auth.isLoggedIn) {
    return <RefreshSpinner fullScreen showBackGround={true} />;
  }

  if (inDemoMode) {
    return <></>;
  }

  // derived, not navigated: firebase-authenticated but no owner name yet
  if (!ownerNameAssociatedWithEmail && auth.isLoggedIn) {
    return <RegisterOwnerName />;
  }

  if (auth.isLoggedIn) {
    return <></>;
  }

  switch (screen) {
    case "signUp":
    case "signUpEmail":
      return <SignUp />;
    case "loginChoices":
    case "loginEmail":
      return <Login data-testid="login" />;
    default:
      return <LoginOrSignUp />;
  }
}

export default Auth;
